import { Link } from "react-router-dom";

function Header() {
  return (
    <>
      {/* <!-- contact details --> */}
      <div className=" contact-bg px-0 w-100 d-lg-flex justify-content-lg-around flex-lg-row  col-md-2   d-sm-flex flex-sm-column col-md-5 pt-lg-1 text-center fw-semibold p-0 m-0 gap-2">
        <div className="">
          <p className=" fw-semibold text-center  text-light">
            Community 9, Opposite Tema General Hospital
          </p>
        </div>
        <div>
          <p className="text-light">+233 55 066 2915 / +233 20 592 5509</p>
        </div>
        <div className="">
          <p className="container text-light d-none d-sm-block">
            rapidlabdiagnostics@gmail.com / info@rapidlabdiagnotics.com
          </p>
        </div>
      </div>
      {/* <!-- Headers --> */}
      <nav className="navbar navbar-expand-lg navbar-light   px-lg-3 px-sm-2  ">
        {" "}
        <img
          loading="lazy"
          width="160"
          height="160"
          src="images/assets/rapidLablogo.png "
          alt="rapidLabLogo"
        />
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className=" collapse navbar-collapse  d-lg-flex justify-content-end  "
          id="navbarNavAltMarkup"
        >
          <nav className="navbar d-flex flex-column flex-md-column  flex-sm-column flex-lg-row align-items-center  px-0  fw-normal  gap-lg-5">
            <div className="p-2">
              <Link
                className="text-primary-emphasis text-decoration-none under-line fs-6  "
                to="/"
              >
                Home
              </Link>
            </div>

            <div className="p-2">
              <Link
                className="text-primary-emphasis text-decoration-none under-line fs-6 "
                to="/about-us"
              >
                About Us
              </Link>
            </div>

            {/* Services Dropdown */}
            <div className="p-2">
              <div className="dropdown services-dropdown">
                <Link
                  className="text-primary-emphasis text-decoration-none fs-5 no-arrow text-decoration-none under-line fs-6 "
                  to="/services"
                >
                  Services
                </Link>

                <ul className="dropdown-menu custom-dropdown  shadow-lg rounded-2 border-1 p-1 gap-2  ">
                  <li>
                    <Link
                      className="dropdown-item text-primary-emphasis"
                      to="/laboratoryServices#lab-services"
                    >
                      Laboratory
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item text-primary-emphasis"
                      to="/DigitalXrayServices#x-ray-services"
                    >
                      Digital X-Ray
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item text-primary-emphasis"
                      to="/HsgServices#hsg-services"
                    >
                      Hysterosalpingogram (HSG)
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item text-primary-emphasis"
                      to="/UltrasoundServices#ultrasound-services"
                    >
                      Ultrasound
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item text-primary-emphasis"
                      to="/SonographyServices#sonography-services"
                    >
                      Sonography
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item text-primary-emphasis"
                      to="/EcgServices#ecg-services"
                    >
                      Electrocardiogram (ECG)
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item text-primary-emphasis"
                      to="/EchoServices#echo-services"
                    >
                      Echocardiogram
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item text-primary-emphasis"
                      to="/MobileConciergeServices#mobile-concierge-services"
                    >
                      Mobile Concierge
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item text-primary-emphasis"
                      to="/CorporateServices#corporate-wellness-services"
                    >
                      Corporate Wellness
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="p-2">
              <Link
                className="text-primary-emphasis text-decoration-none under-line fs-6 "
                to="/packages"
              >
                Packages
              </Link>
            </div>
            <div className="p-2">
              <Link
                className=" text-primary-emphasis   fw-normal text-decoration-none under-line fs-6"
                to="/forms"
              >
                Contact Us
              </Link>
            </div>
            <div className=" pt-0">
              <Link to="/forms">
                <button type="button" className="btn btn-primary  text-light ">
                  Request An Appointment
                </button>
              </Link>
            </div>
            {/* <!-- modal --> */}
            <div
              className="modal fade opacity-2 glass-morph"
              id="exampleModal"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header d-flex justify-content-between">
                    <div>
                      <h5 className="text-center text-primary-emphasis">
                        CONTACT US
                      </h5>

                      <h4
                        className="modal-title text-center"
                        id="exampleModalLabel"
                      >
                        Request An Appointment
                      </h4>
                    </div>
                    <button
                      type="button"
                      className="close btn btn-outline-secondary "
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body "></div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </nav>
    </>
  );
}

export default Header;
